import { Directive, HostBinding, Input, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store, createSelector } from '@ngrx/store';

import { BetslipType } from '../../../core/betslip-type';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { RemoveButtonStyle } from '../../picks/components/digital/pick-remove-button/remove-button-style';
import { RemoveButtonPosition } from '../../single-bet/remove-button-position-enum';
import { selectSystemBetPicks } from '../../types/selectors';
import { orderPicksByTypeState } from '../../utils/bet-type.utils';
import { systemBetStateSelector } from '../selectors';
import { ISystemBetPickState, ISystemBetState } from '../state';

const selectSystemBetState = createSelector(systemBetStateSelector, selectSystemBetPicks, (systemBetState, pickList) => ({
    systemBetState,
    pickList: orderPicksByTypeState(pickList, systemBetState),
}));

@Directive()
export default abstract class BaseSystemBetComponent {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() removeButtonPosition: RemoveButtonPosition;
    @Input() removeButtonStyle: RemoveButtonStyle;

    viewModel = toSignal(this.store.select(selectSystemBetState), { requireSync: true });
    isBankerActiveSignal = computed(() => this.viewModel().systemBetState.isBankerActive);

    @HostBinding('class.betslip-system-bet-banker--is-visible') get isBankerActive(): boolean {
        return this.isBankerActiveSignal();
    }

    betslipType = BetslipType.System;

    protected constructor(protected store: Store) {}

    pickTrackBy(index: number, pick: BetslipPick): string {
        return pick.id.toString();
    }

    systemBetPick(state: ISystemBetState, pick: BetslipPick): ISystemBetPickState {
        return state.picks[pick.id.toString()];
    }
}
